import React, { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { getLogingStaffList } from "../../redux/services/Staff Services/Staff.Services";
import Pagination from "../../common/Pagination";
import { Link } from "react-router";
const LoginStaffList = () => {
  const [staffData, setActivityData] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);

  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [showPassword, setShowPassword] = useState({});

  const fetchStaff = async (pageNo = 1,
    isInitialLoad = false) => {
    try {
      if (isInitialLoad) {
        setInitialLoading(true);
      } else {
        setTableLoading(true);
      }

      const payload = {
        page: pageNo,
        per_page: limit,
      };

      const response = await getLogingStaffList(payload);

      if (response?.data?.success) {
        setActivityData(response.data.data || []);
        setPage(response?.data?.current_page || 1);
        setTotalPages(response?.data?.last_page || 1);
        setTotalRecords(response?.data?.total || 0);
      }
    } catch (error) {
      console.error("Failed to fetch staff:", error);
      setActivityData([]);
    } finally {
      setInitialLoading(false);
      setTableLoading(false);
    }
  };

  useEffect(() => {
    fetchStaff(1, true);
  }, [limit]);

  const formatDateTime = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    const formattedDate = date.toLocaleDateString("en-GB").replace(/\//g, "-");

    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    return `${formattedDate} ${formattedTime}`;
  };
  const handlePageChange = (newPage) => {
    if (
      newPage >= 1 &&
      newPage <= totalPages &&
      !tableLoading
    ) {
      setPage(newPage);
      fetchStaff(newPage, false);
    }
  };
  if (initialLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }
  return (
   <>
       <div className="d-flex align-items-center justify-content-between  page-header-breadcrumb">
        <div className="title_member">
          <h4>Active Staff</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Staff</span>
          </nav>
        </div>
      </div>


   <div className="main_page">
     <div className="lead-page">
    

     
      
        {totalPages > 1 && (
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">

            {/* <div className="d-flex align-items-center gap-2">
    <label className="mb-0">Show</label>

    <select
      className="form-select form-select-sm"
      value={limit}
      onChange={(e) => {
        setLimit(Number(e.target.value));
        setPage(1);
      }}
    >
      <option value={10}>10</option>
      <option value={25}>25</option>
      <option value={50}>50</option>
      <option value={100}>100</option>
    </select>
  </div> */}

            <div className="col-12 d-flex justify-content-end">

              <Pagination
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>

          </div>
        )}
        <div className="st-wrapper-card">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Employee ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Password</th>
                  <th>Last Login</th>
                  <th>Last Logout</th>
                  <th>IP Address</th>
                </tr>
              </thead>

              <tbody>
                {tableLoading ? (
                  <tr>
                    <td colSpan="8" className="text-center py-5">
                      <div className="spinner-border text-primary"></div>
                    </td>
                  </tr>
                ) : staffData.length > 0 ? (
                  staffData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(page - 1) * limit + index + 1}</td>

                      <td>{item.employee_id || "-"}</td>

                      <td>{item.admin?.name || "-"}</td>

                      <td>{item.admin?.email || "-"}</td>

                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <span>
                            {showPassword[item.id]
                              ? item.admin?.simple_pass || "-"
                              : "••••••••"}
                          </span>

                          <button
                            type="button"
                            className="btn btn-link p-0 border-0 shadow-none"
                            onClick={() =>
                              setShowPassword((prev) => ({
                                ...prev,
                                [item.id]: !prev[item.id],
                              }))
                            }
                          >
                            {showPassword[item.id] ? (
                              <FaEyeSlash />
                            ) : (
                              <FaEye />
                            )}
                          </button>
                        </div>
                      </td>

                      <td>{formatDateTime(item.last_login_at)}</td>

                      <td>{formatDateTime(item.last_logout_at)}</td>

                      <td>{item.last_login_ip || "-"}</td>
                    </tr>
                  ))

                ) : (

                  <tr>
                    <td colSpan="8" className="text-center py-4">
                      No Data Found
                    </td>
                  </tr>

                )}
              </tbody>
            </table>
            {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
   </div>
   </>


  );
};

export default LoginStaffList;